import { FC } from 'react'
import { Colors } from 'src/components/theme'
import { WidgetCard } from 'src/v2/components/widget-card'
import { ParcelPropertyDebtsContent } from 'src/v2/views/owner-reveal/insights/parcel-insights/property-records/property-debts/content'

export const ParcelPropertyDebtsWidget: FC = () => {
  return (
    <WidgetCard
      id="property-debts"
      title="Property Debts"
      headerBgColor={Colors.primaryGreen700}
      headerTextColor={Colors.textWhite}
      sections={[
        {
          content: <ParcelPropertyDebtsContent />,
        },
      ]}
    />
  )
}
